package com.exura.features.plandefinition.domain.model.plan

/**
 * Defines the type of plan, which affects how element dates are calculated.
 */
enum class PlanType {
    /**
     * A preparation plan where elements count backward from an anchor date
     * (typically a surgery or visit date)
     */
    PREPLAN,

    /**
     * A treatment plan where elements count forward from an anchor date
     * (typically the start of treatment)
     */
    POSTPLAN,
}
